import styled from 'styled-components'

import { COLOR } from '@/shared/constant/color'
import { customMedia } from '@/styles/common/common'

const HealthWrap = styled.div`
  display: block;
  max-width: 800px;
  width: 100%;
  margin: 76px auto 240px auto;
  ${customMedia.lessThan('tablet')`
     max-width: 600px;
     margin: 38px auto 124px auto;
  `}
  ${customMedia.lessThan('tablet_cut_line')`
     max-width: 328px;
   `}
`
const HealthTitle = styled.p`
  display: block;
  margin: 0 auto 28px auto;
  text-align: center;
  padding-top: 119px;
  font-size: 36px;
  font-family: NotoSansBold, sans-serif;
  line-height: 52px;
  white-space: pre-line;

  &.health {
    &:before {
      display: block;
      content: '헬스';
      font-family: NotoSansRegular, sans-serif;
      font-size: 16px;
      line-height: 23px;
      color: ${COLOR.point1};
    }
  }

  &.life {
    &:before {
      display: block;
      content: '라이프';
      font-family: NotoSansRegular, sans-serif;
      font-size: 16px;
      line-height: 23px;
      color: ${COLOR.point1};
    }
  }

  ${customMedia.lessThan('tablet')`
     padding-top: 38px;
     font-size: 24px;
     line-height: 35px;
  `}
  ${customMedia.lessThan('tablet_cut_line')`
     
   `}
`
const HealthContent = styled.div`
  > img {
    border-radius: 20px;
    width: 800px;
    height: 600px;
    margin: 0 auto 47px auto;
    ${customMedia.lessThan('tablet')`
     width: 600px;
     height: 450px;
  `}
    ${customMedia.lessThan('tablet_cut_line')`
     width: 328px;
     height: 246px;
   `}
  }

  > p {
    font-size: 16px;
    line-height: 23px;
    font-family: NotoSansRegular, sans-serif;
    margin: 0 0 -8px 0;
    white-space: pre-wrap;
  }
`
const HealthContentException = styled.p<{ size: string }>`
  font-size: 14px;
  line-height: 20px;
  display: inline-block;
  p {
    //line-height: 2px !important;
  }
  img {
    max-width: ${(props) => props.size} !important;
  }
`
export { HealthContent, HealthContentException, HealthTitle, HealthWrap }
